import { ChangeDetectorRef, Component, computed, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { SummaryComponent } from '../summary/summary.component';
import { FormService } from '../service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdditionalServiceOptionComponent } from '../../../../../../components/additional-service-option/additional-service-option.component';
import { MatStepper } from '@angular/material/stepper';
import { TopNavbarComponent } from '../../../../../components/top-navbar/top-navbar.component';
import { AsyncPipe } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-step-additional-services',
  imports: [
    TranslocoModule,
    SummaryComponent,
    AdditionalServiceOptionComponent,
    MatSlideToggleModule,
    MatTooltipModule,
    TopNavbarComponent,
    AsyncPipe
  ],
  templateUrl: './step-additional-services.component.html',
  styleUrl: './step-additional-services.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'style': 'font-family: Inter, sans-serif;'
  }
})
export class StepAdditionalServicesComponent implements OnInit {
  selectedParking: any;
  additionalServices: any;
  additionalServicesControls: any;
  isRemoved = false;
  @Input() stepper: MatStepper | null = null;
  mandatoryServicesIds = computed(() => {
    return Array.from(this._form.mandatoryServices()).map(group => group.controls['id'].value);
  });

  constructor(
    public _form: FormService,
    private _cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    // Try to get additionalServices from selectedParking on init
    this.selectedParking = this._form.getForm().get('parking').get('selectedParking').value;
    this.additionalServices = this.selectedParking?.additionalServices ?? [];
    if (this.additionalServices && this.additionalServices.length > 0) {
      this.additionalServices.forEach(function (element: any, index: any) {
        if (typeof element.name === 'string') {
          element.name = JSON.parse(element.name);
        }
        if (typeof element.description === 'string') {
          element.description = JSON.parse(element.description);
        }
      });
      // Update form array with initial additional services
      this._form.updateFormArray(this.additionalServices);
      this.additionalServicesControls = this._form.getForm().get('parking.additionalServices').controls;
    }

    // Subscribe to changes in selectedParking
    this._form.getForm().get('parking').controls.selectedParking.valueChanges.subscribe((value: any) => {
      this.selectedParking = value;
      this.additionalServices = this.selectedParking?.additionalServices ?? [];
      if (this.additionalServices && this.additionalServices.length > 0) {
        this.additionalServices.forEach(function (element: any, index: any) {
          if (typeof element.name === 'string') {
            element.name = JSON.parse(element.name);
          }
          if (typeof element.description === 'string') {
            element.description = JSON.parse(element.description);
          }
        });
        this._form.updateFormArray(this.additionalServices);
      }
    });

    // Subscribe to changes in parking.additionalServices
    this._form.getForm().get('parking.additionalServices').valueChanges.subscribe((change: any) => {
      this.additionalServicesControls = this._form.getForm().get('parking.additionalServices').controls;
      this._cdRef.detectChanges();
    });
  }

  goNext(): void {
    this.stepper!.next();
  }

  goBack(): void {
    this.stepper!.previous();
  }

}
